import React from 'react';
import { Footer } from '../components';

export function FooterContainer() {
    return (
        <Footer>
            <Footer.InnerContainer>
                <Footer.Text>© 2021 Eternal Possibilities</Footer.Text>
            </Footer.InnerContainer>
        </Footer>
    )
}